// extracted by mini-css-extract-plugin
export var searchHeader = "_a3-0";
export var searchHeaderDark = "_a3-1";